import React from 'react';

const Pagination = ({ currentPage, totalPages, handlePageChange, generatePageNumbers }) => {
    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: '20px 0',
            gap: '20px',
            width: '100%'
        },
        pageInfo: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            color: '#666'
        },
        pageNumber: {
            fontWeight: 'bold',
            color: '#28a745'
        },
        buttonGroup: {
            display: 'flex',
            gap: '8px',
            alignItems: 'center'
        },
        button: {
            padding: '8px 12px',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            color: '#28a745',
            cursor: 'pointer',
            fontSize: '14px',
            transition: 'all 0.2s ease',
            minWidth: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        activeButton: {
            backgroundColor: '#28a745',
            color: '#ffffff',
            border: '1px solid #28a745'
        },
        disabledButton: {
            backgroundColor: '#f5f5f5',
            color: '#bdbdbd',
            cursor: 'not-allowed',
            border: '1px solid #e0e0e0'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.pageInfo}>
                <span>Page</span>
                <span style={styles.pageNumber}>{currentPage}</span>
                <span>of</span>
                <span style={styles.pageNumber}>{totalPages}</span>
            </div>

            <div style={styles.buttonGroup}>
                <button
                    style={{
                        ...styles.button,
                        ...(currentPage === 1 ? styles.disabledButton : {})
                    }}
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>

                {generatePageNumbers(currentPage, totalPages).map((page, index) => (
                    <button
                        key={`page-${index}`}
                        style={{
                            ...styles.button,
                            ...(currentPage === page ? styles.activeButton : {})
                        }}
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </button>
                ))}

                <button
                    style={{
                        ...styles.button,
                        ...(currentPage === totalPages ? styles.disabledButton : {})
                    }}
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Pagination;